export default __webpack_public_path__ + "static/media/login-video.fe3b961e.mp4";